import { Dialog, DialogTitle, Typography, IconButton, DialogContent, DialogActions, Button } from "@mui/material"
import {
    CloseOutlined as CloseOutlinedIcon,
} from '@mui/icons-material'
import { ReserveClubhouseRequestData } from "../../clients"

interface MyClubhouseReservationRequestDialogProps {
    open: boolean
    request: ReserveClubhouseRequestData | null
    handleClose: () => void
    handleDeleteRequest: (request: ReserveClubhouseRequestData) => void
}

export const MyClubhouseReservationRequestDialog = ({ open, request, handleClose, handleDeleteRequest }: MyClubhouseReservationRequestDialogProps) => {
    
    const getFriendlyStatusName = (status: string) => {
        switch (status) {
            case 'approved':
                return 'Approved'
            case 'denied':
                return 'Denied'
            case 'pending':
                return 'Pending'
            default:
                return 'Unknown'
        }
    }
    
    if (!request) {
        return null
    }
    
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>
                <Typography variant='h3' sx={{ fontSize: '1.5rem', fontWeight: 400, mt: 1 }}>
                    Clubhouse Reservation Request
                </Typography>
            </DialogTitle>
            <IconButton sx={{
                position: 'absolute',
                right: 16,
                top: 16,
                color: (theme) => theme.palette.grey[500],
            }} onClick={handleClose}>
                <CloseOutlinedIcon />
            </IconButton>
            <DialogContent sx={{ px: 6 }}>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2 }}>Requested Dates</Typography>
                <Typography variant='body1'>
                    {request.reserveClubhouseRequestBeginDate.toLocaleDateString(undefined, {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                    })} - {request.reserveClubhouseRequestEndDate.toLocaleDateString(undefined, {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                    })}
                </Typography>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2 }}>Notes</Typography>
                <Typography variant='body1'>
                    {request.reserveClubhouseRequestNotes}
                </Typography>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2 }}>Request Created</Typography>
                <Typography variant='body1'>
                    {request.reserveClubhouseRequestCreatedDate.toLocaleDateString(undefined, {
                        weekday: 'short',
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric',
                        hour12: true,
                    })}
                </Typography>
                <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2 }}>Request Status</Typography>
                <Typography variant='body1'>
                    {getFriendlyStatusName(request.reserveClubhouseRequestStatus)}
                </Typography>
                {
                    request.reserveClubhouseRequestResponse &&
                    <>
                        <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2 }}>Request Response</Typography>
                        <Typography variant='body1'>
                            {request.reserveClubhouseRequestResponse}
                        </Typography>
                    </>
                }
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                {
                    request.reserveClubhouseRequestStatus === 'pending' &&
                    <Button variant='contained' color='error' onClick={() => handleDeleteRequest(request)}>
                        Delete Request
                    </Button>
                }
            </DialogActions>
        </Dialog>
    )
}